import { ActionProcessMode, CategoryName } from '@infotech-soe/metaschema';

import MerpsApiProvider from '../../../infrastructure/providers/pb-adapter/MerpsApiProvider';
import {
  BuiltinCaptionType,
  CaptionType,
} from '../../../models/caption/Caption';
import { ClientContext } from '../../context/IContextService';
import { TreeFormFieldNames } from '../../form/schema-factory/TreeFormSchemaFactory';
import { CommandName } from '../CommandViewModel';
import { MoveFormUserInteractor, UserInteractorType } from '../UserInteractor';

import CategoryCommandImpl from './CategoryCommandImpl';

export default class MoveRecordCommandImpl extends CategoryCommandImpl<any> {
  constructor(private category: CategoryName) {
    super();
  }

  public async execute(
    context: ClientContext,
    args: any
  ): Promise<void | Record<string, any>> {
    return new MerpsApiProvider().rpc.callMethod('queries', 'documentMove', [
      context.get('Category'),
      context.get('Id'),
      args[TreeFormFieldNames.TARGET_ID],
    ]);
  }

  public getUserInteractor(): MoveFormUserInteractor {
    return {
      type: UserInteractorType.MOVE_FORM,
      action: 'move',
      caption: {
        caption: BuiltinCaptionType.MOVE,
        type: CaptionType.BUILT_IN,
      },
      category: this.category,
    };
  }

  public async getInitialArgs(): Promise<any> {
    // not implemented
  }

  public getName(): CommandName {
    return 'move';
  }

  public getProcessMode(): ActionProcessMode {
    return 'Sequential';
  }
}
